import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { LocalStorageProvider } from '../providers/local-storage';

@Injectable()
export class ClubeProvider {

  dados: any = [];
  pagina: number = 1;
  hasmore: boolean = false;

  contentHeader: Headers = new Headers(HEADERS);

  constructor(public http: Http, public localStorage: LocalStorageProvider) {

  }

  refresh() {
    this.pagina = 1;
    this.hasmore = false;
    this.dados = [];
  }

  setPage(page) {
    this.pagina = page;
  }

  checkHasmore() {
    return this.hasmore;
  }

  clientePoints(id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'clube/clientePoints', JSON.stringify({ usuario_id: id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.localStorage.storageSave('pontos', data.response)
          resolve(data.response)
        },
        err => {
          reject(err)
        }
        );
    });
  }

  clubeProdutos() {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'clube/clubeProdutos', JSON.stringify({ pagina: this.pagina }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.hasmore = data.hasmore;

          if (this.hasmore) {
            this.setPage(this.pagina + 1);
          }

          for (var item of data.produtos) {
            this.dados.push(item);
          }

          resolve(this.dados);
        },
        err => {
          reject(err)
        }
        );
    });
  }

  clubeRegistrarNtf(code, id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'clube/registrarNF', JSON.stringify({ code: code, id: id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err)
        }
        );
    });
  }

  clubeSalvarNtf(code, id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'clube/salvarNF', JSON.stringify({ chNFe: code, id: id }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data);
        },
        err => {
          reject(err)
        }
        );
    });
  }

  clubeRegulamento() {
    return new Promise((resolve, reject) => {
      this.http.get(SERVER_URL + 'clube/clubeRegulamento', { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          resolve(data.regulamento);
        },
        err => {
          reject(err)
        }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/clube.ts